import React from 'react'
import  {Dashboard } from 'components';
const AdminDashboard = () => {
  return (
    <div><Dashboard/></div>
  )
}

export default AdminDashboard